<template>
  <section>
    <VerReporte />
    <v-card>
      <v-card-title class="headline m-0">
        <v-flex xs9>
          <v-icon>picture_as_pdf</v-icon> Reportes de vacación
        </v-flex>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="py-0">
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-container grid-list-md style="min-width: 100%;" class="p-0">
            <v-layout wrap>
              <v-flex md6>
                <strong>FUNCIONARIO: </strong>{{ $storage.get("user").nombres }}
                {{ $storage.get("user").ap_paterno }}
                {{ $storage.get("user").ap_materno }}
              </v-flex>
            </v-layout>
            <!--Reportes -->
            <v-layout wrap justify-center align-center class="text-xs-center">
              <v-flex md6 xs12>
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="fecha_desde"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  color="#16516f"
                  label="Fecha desde"
                />
              </v-flex>
              <v-flex md6 xs12>
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="fecha_hasta"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  color="#16516f"
                  label="Fecha hasta"
                />
              </v-flex>
              <v-flex md6 xs12>
                <v-btn color="#812595" dark @click="verReporte(1)">
                  Generar Reporte de vacaciones
                  <v-icon>description</v-icon>
                </v-btn>
              </v-flex>
              <v-flex md6 xs12>
                <v-btn color="pink" dark @click="verReporte(2)">
                  Generar Reporte programación anual
                  <v-icon>picture_as_pdf</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12>
                <HistoricoPeriodosVacacion />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

import VerReporte from "../asistencia/dialogs/VerReporte.vue";
import HistoricoPeriodosVacacion from "./components/HistoricoPeriodosVacacion.vue";
export default {
  components: { VerReporte, HistoricoPeriodosVacacion },
  mixins: [validate],
  data() {
    return {
      form: {},
      loading: false,
      fecha_desde: null,
      fecha_hasta: null,
      valid: false
    };
  },
  async mounted() {
    var date = new Date();
    let año = new Date().getFullYear() + "";
    let primer_dia = año + "-01-01";
    let ultimo_dia = año + "-12-31";
    this.fecha_desde = primer_dia;
    this.fecha_hasta = ultimo_dia;
  },
  methods: {
    verReporte(valor) {
      if (valor == 2) {
        if (!this.fecha_desde || !this.fecha_hasta) {
          this.$message.info(
            `Debe ingresar los parametros Fecha desde y Fecha hasta para generar el reporte`
          );
          return;
        }
      }
      let user = this.$storage.get("user");

      let url;
      let nombre_reporte = "";
      let formato_doc = "output=pdf";
      let nombre_carpeta = "vacaciones";
      let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(
        /{carpeta}/g,
        nombre_carpeta
      );

      let url_parametros = null;
      if (valor == 1) {
        nombre_reporte = "rpt_cronograma";
      }
      if (valor == 2) {
        nombre_reporte = "rpt_cronograma_vacacion";
      }
      url = `${url_carpeta}${nombre_reporte}&${formato_doc}`;

      // URL con parametros
      if (valor == 1) {
        url_parametros = `${url}&id_unidad=${user.unidad[0].id}&id_persona=${user.id_persona}`;
        console.log("+++++++++++++++++++", url_parametros);
      }
      if (valor == 2) {
        url_parametros = `${url}&p_fecha_ini=${this.fecha_desde}&p_fecha_fin=${this.fecha_hasta}&p_unidad_general=0&p_paterno=&p_materno=&p_nombres=&p_ci=${user.nro_doc}&p_item=&p_unidad_especifica=0`;
        console.log("+++++++++++++++++++", url_parametros);
      }
      this.$bus.$emit("openDialogVerReporte", url_parametros);
    }
  }
};
</script>

<style>
.color_letras {
  color: azure;
}
.letras_titulo {
  color: azure;
  font-family: Arial, Helvetica, sans-serif;
  font: 1em sans-serif;
  background-color: rgb(40, 40, 165);
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacaciones/ReporteVacacionesFuncionario.vue